import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const businessOwnershipApi = createApi({
  reducerPath: 'BusinessOwnership',
  tagTypes: ['BusinessOwnership'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getBusinessOwnershipTableData: builder.mutation({
      query: (
        { page, size, body = {} },
        params = { sortBy: 'id', sortDir: 'desc' }
      ) => ({
        url: `/v1/contractors/business-owner-ship/contractor?page=${page}&size=${size}`,
        method: 'POST',
        body,
        params,
      }),
    }),
    getBusinessOwnershipById: builder.query({
      query: ({ id }) => ({
        url: `/v1/contractors/business-owner-ship/${id}`,
      }),
    }),
    createOrUpdateBusinessOwnership: builder.mutation({
      query: ({ id, body, method }) => ({
        url: `/v1/contractors/business-owner-ship/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
  }),
});

export const {
  useGetBusinessOwnershipTableDataMutation,
  useLazyGetBusinessOwnershipByIdQuery,
  useCreateOrUpdateBusinessOwnershipMutation,
} = businessOwnershipApi;
